import { render } from "./MediaflowGraphicsDock.vue?vue&type=template&id=acb3669a&scoped=true"
import script from "./MediaflowGraphicsDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowGraphicsDock.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowGraphicsDock.vue?vue&type=style&index=0&id=acb3669a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb3669a"],['__file',"src/components/Mediaflow/MediaflowGraphicsDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acb3669a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acb3669a', __exports__)) {
    api.reload('acb3669a', __exports__)
  }
  
  module.hot.accept("./MediaflowGraphicsDock.vue?vue&type=template&id=acb3669a&scoped=true", () => {
    api.rerender('acb3669a', render)
  })

}


export default __exports__